<template>
  <div>
    <!-- toolbar -->
    <v-toolbar class="purple darken-4">
      <v-btn @click="drawer = true" dark icon>
        <v-icon>menu</v-icon>
      </v-btn>
      <img src="@/assets/logo.png" style="width:10%;height:auto" class="logo" alt="logo" />
      <v-toolbar-items class="mr-4 text-xs-center hidden-sm-and-down">
        <v-btn flat dark x-large :to="{name:'index'}">صفحه نخست</v-btn>
        <v-menu open-on-hover bottom offset-y transition="slide-y-reverse-transition">
          <template v-slot:activator="{ on }">
            <v-btn dark flat x-large v-on="on">
              <v-icon>account_circle</v-icon>&nbsp;
              خدمات &nbsp;&nbsp;
              <v-icon small>expand_more</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile v-for="(item, index) in items" :key="index" :to="item.route">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-btn flat dark x-large :to="{name:'newrequest'}">درخواست نمایندگی فروش</v-btn>

        <v-btn flat dark x-large>درباره ما</v-btn>
        <v-btn flat dark x-large>تماس با ما</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat dark x-large v-if="!this.$store.state.isUserLoggedIn" :to="{name:'login'}">ورود</v-btn>
        <v-btn flat dark x-large v-if="this.$store.state.isUserLoggedIn" :to="{name:'home'}">داشبورد</v-btn>
        <v-btn flat dark x-large v-if="this.$store.state.isUserLoggedIn">{{this.$store.state.user.name}}</v-btn>
        <v-btn flat dark x-large v-if="this.$store.state.isUserLoggedIn" @click="logout">خروج</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-autocomplete
        :items="SearchItems"
        no-data-text="نتیجه یافت نشد"
        class="text-search"
        solo
        background-color="rgba(255,255,255,0.8)"
        append-icon="search"
        placeholder="جستجو کنید"
      ></v-autocomplete>
    </v-toolbar>

    <!-- navigation menu -->

    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img src="@/assets/logo2.png" style="width: 80px !important" />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>دسترسی سریع منو</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>

        <v-list-tile v-for="navmenus in mnavigation" :to="{name:navmenus.route}" :key="navmenus.title">
          <v-list-tile-action>
            <v-icon color="cyan lighten-1">{{ navmenus.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="txt-right">{{ navmenus.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import { mapState } from "vuex";
export default {
  computed: mapState([
  'isUserLoggedIn'
]),
  data() {
    return {
      drawer: false,
      items: [
        {
          index: 0,
          title: "مدیریت داوران",
          route: "r"
        },
        {
          index: 1,
          title: "مدیریت داوران",
          route: "r"
        },
        {
          index: 2,
          title: "مدیریت داوران",
          route: "r"
        },
        {
          index: 3,
          title: "مدیریت داوران",
          route: "r"
        }
      ],
      mnavigation: [
        { title: "صفحه اصلی", icon: "dashboard", route: "index" },
        { title: "جدول مسابقات", icon: "view_quilt", route: "" },
        { title: "اخبار جدید", icon: "web", route: "" },
        { title: "درباره ما", icon: "live_help", route: "" },
        { title: "قوانین و مقررات", icon: "bug_report", route: "" },
        { title: "سوالات متداول", icon: "info", route: "" },
        { title: "تماس با ما", icon: "call", route: "" }
      ],
      SearchItems: [
        { text: "قزوین", value: "qaz" },
        { text: "کرج", value: "krj" },
        { text: "سمنان", value: "smn" },
        { text: "تهران", value: "teh" }
      ]
    };
  },methods: {
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$router.push({ name: "index" });
    }
  }
};
</script>

<style scoped>
.text-search {
  width: 5px !important;
  margin-top: 9px !important;
}
</style>
